module.exports = __webpack_public_path__ + "media/images/RCPAQAP_seal-7a3f5697.png";